<template>
  <vue-apex-charts
    type="bar"
    :height="height"
    :options="chartOptions"
    :series="series"
  />
</template>
<script>
import VueApexCharts from "vue-apexcharts";
import themeConfig from "@themeConfig";

export default {
  components: {
    VueApexCharts,
  },
  props: ["categories", "series", "height"],
  setup(props) {
    const chartOptions = {
      chart: {
        toolbar: {
          show: true,
        },
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: "60%",
          endingShape: "rounded",
        },
      },
      grid: {
        xaxis: {
          lines: {
            show: false,
          },
        },
      },
      colors: themeConfig.themes.light.primary,
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: props.categories,
        tickAmount: 1,
        labels: {
          show: true,
          trim: false,

          style: {
            fontSize: "12px",
          },
          formatter: function (value, timestamp, opts) {
            return value;
          },
        },
      },
      yaxis: {
        labels: {
          show: true,
          trim: false,

          style: {
            fontSize: "12px",
          },

          //   format: undefined,
          //   formatter: undefined,
          //   datetimeUTC: true,
          //   datetimeFormatter: {
          //     year: "yyyy",
          //     month: "MMM 'yy",
          //     day: "dd MMM",
          //     hour: "HH:mm",
          //   },
        },
      },
    };

    return { chartOptions };
  },
};
</script>
